import { Form } from "react-bootstrap";
import styled from "styled-components";
import { useThemeContext } from "../../theme/ThemeContext";

const Container = styled.div`
  position: absolute;
  bottom: 30px;
  right: 0.5em;
  z-index: 101;

  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color);
  padding: 10px 14px;
  border-radius: 8px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  display: flex;
  align-items: center;
  gap: 8px;

  font-size: 14px;
`;

const SatelliteSwitch = () => {
  const { satelliteMode, toggleSatelliteMode } = useThemeContext();

  return (
    <Container>
      <Form.Check
        id="satellite-view-toggle"
        type="switch"
        label="Satellite View"
        checked={satelliteMode}
        onChange={(e) => toggleSatelliteMode()}
      />
    </Container>
  );
};

export default SatelliteSwitch;
